export default "__VITE_ASSET__f282f849__"